import axios from '../config/axios';

export interface InquiryData {
    propertyId?: string;
    name: string;
    email: string;
    phone: string;
    message: string;
    inquiryType?: 'property' | 'general';
}

export const createInquiry = async (data: InquiryData) => {
    try {
        const response = await axios.post("/api/inquiry", data);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getInquiries = async (filters?: { [key: string]: any }) => {
    try {
        const response = await axios.get("/api/inquiry", {
            params: filters
        });
        return {
            data: response.data.data,
            pagination: response.data.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getInquiryStats = async () => {
    try {
        const response = await axios.get("/api/inquiry/stats");
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAdminInquiryStats = async () => {
    try {
        const response = await axios.get('/api/admin/AllSignupStats');
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const getAllAdminInquiries = async (filters?: { [key: string]: any }) => {
    try {
        const response = await axios.get('/api/admin/AllSignup', {
            params: filters
        });
        return {
            data: response.data.data,
            pagination: response.data.pagination
        };
    } catch (error: any) {
        throw error.response?.data || error;
    }
};
